import React from "react";
import Page from "../components/Page";
import { Card, Container, Grid, Stack, Typography } from "@mui/material";
import BalanceGeneralReport from "../sections/@reporteador/BalanceGeneralReport";

const Balance = () => {
  return (
    <>
      <Page title="Balance General">
        <Container maxWidth="xl">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              {" "}
              Balance General
            </Typography>
          </Stack>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Card>
                <BalanceGeneralReport/>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Page>
    </>
  );
};

export default Balance;
